import { React, useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { useSnackbar } from 'notistack';
import TokenService from '../../../services/TokenService';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DownloadIcon from '@mui/icons-material/Download';

export default function MarketingRequestItem(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [marketingRequest, setMarketingRequest] = useState(props.MarketingRequest);
    const [finalCost, setFinalCost] = useState('');
    function handleDownloadFlyer() {
        let postData = {
            flyerName: marketingRequest.ItemName,
            nameType: marketingRequest.NameType,
            returnerId: marketingRequest.ReturnerId
        }
        TokenService.adminServicePost(postData, 'Admin_DownloadFlyer')
            .then((response) => {
                //response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    downloadImage(jsonData.Flyer, 'Sipzee_Flyer.png');


                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function downloadImage(base64Image, fileName) {
        // Convert Base64 to Uint8Array
        var byteCharacters = atob(base64Image);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the Uint8Array
        var blob = new Blob([byteArray], { type: 'image/png' });

        // Create a URL for the Blob
        var url = URL.createObjectURL(blob);

        // Create a temporary anchor element
        var link = document.createElement('a');
        link.href = url;
        link.download = fileName;

        // Trigger the download
        link.click();

        // Clean up the URL and anchor element
        URL.revokeObjectURL(url);
    }

    function handleFinalCostChange(event) {
        let inputValue = event.target.value;
        // Remove non-numeric and non-decimal characters
        const numericValue = inputValue.replace(/[^0-9.]/g, '');
        // Limit decimal precision to 2
      //  const roundedValue = parseFloat(numericValue).toFixed(2);
        if (countDecimalPlaces(numericValue) > 2) {
           numericValue = parseFloat(numericValue).toFixed(2);
        }
        setFinalCost(numericValue);

        
    }

    function countDecimalPlaces(number) {
        const decimalIndex = number.toString().indexOf('.');
        if (decimalIndex !== -1) {
            return number.toString().length - decimalIndex - 1;
        }
        return 0;
    };

    function validateAndSave() {
        if (finalCost == '') {
            enqueueSnackbar('Printing Cost required. Use 0 if needed.', {
                variant: 'error',
            });
        }
        else {
            let postData = {
               id: marketingRequest.Id,
                printingCost: finalCost
            }
            TokenService.adminServicePost(postData, 'Admin_CompleteFlyer')
                .then((response) => {
                    //response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        enqueueSnackbar('Updated', {
                            variant: 'success',
                        });
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        }); }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
    }

    return (
        <Card style={{maxWidth:'500px', margin:'10px', padding:'10px'} }>
            <div style={{ display: 'flex', justifyContent:'space-between' }}>
                <div>
                    <div style={{ fontSize: '16pt', color: 'var(--sipzee-green)', fontWeight: 'bold', borderBottom: '1px solid #efefef' }}>Shipping Info:</div>
                    <div>{marketingRequest.FirstName} {marketingRequest.LastName}</div>
                    <div>
                        {marketingRequest.ShippingStreet}
                        {marketingRequest.ShippingStreet2.trim() == '' ? null :
                            <div>
                                {marketingRequest.ShippingStreet2}
                            </div>
                        }
                    </div>
                    <div>
                        {marketingRequest.ShippingCity}, {marketingRequest.ShippingState} {marketingRequest.ShippingZip}
                    </div>
                    <div>
                        <Button variant='outlined' onClick={() => handleDownloadFlyer()}>Download <DownloadIcon /></Button>
                    </div>
                </div>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'} }>
                    <div>
                        <TextField value={finalCost}
                            style={{maxWidth:'150px'} }
                            onChange={(e) => handleFinalCostChange(e)}
                            placeholder='Printing Cost'></TextField>
                    </div>
                    <div>
                        <Button style={{ backgroundColor: 'var(--sipzee-yellow)' }}
                            onClick={() => validateAndSave() }>Mark as Complete</Button>
                    </div>
                </div>
            </div>
            
        </Card>
    )
}